import useThemeConfig from "src/themes/useThemeConfig";
import React from "react";

export default function ProductFilters(props) {
  const config = useThemeConfig();
  const ThemedFilters = config.components.ProductFilters;

  return <ThemedFilters {...props} />;
}
